export const getFullDomain = () => {
  return window.location.hostname;
};
